import { render, staticRenderFns } from "./ArticleCategoryEdit.vue?vue&type=template&id=39537cf0"
import script from "./ArticleCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ArticleCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports